import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import uniqueId from 'lodash/uniqueId'

import { REWARD_TYPE, CLIENT_REWARD_TYPE } from '../../constants'
import { hideTooltip, showItemTooltip } from 'helpers/web_to_client'
import { Bons, Gold } from 'react-wot-bootstrap'
import { thousands } from 'react-wot-bootstrap/lib/helpers/format_number'
import RewardTooltip from '../RewardTooltip/RewardTooltip'
import cx from 'classnames'

import styles from './Reward.scss'

export class Reward extends PureComponent {
    static propTypes = {
        reward: PropTypes.object.isRequired,
    }

    componentWillUnmount() {
        clearTimeout(this._tooltipTimeoutId)
    }

    _tooltipTimeoutId = 0
    _tooltipMedal = uniqueId('tooltip_medal_');

    get medalTooltipId() {
        const { type, id } = this.props.reward
        return `${this._tooltipMedal}${type}_${id}`
    }

    get isMedalReward() {
        return this.props.reward.type.includes('medal')
    }

    handleMouseEnter = () => {
        if (this.isMedalReward) {
            return
        }

        this._tooltipTimeoutId = window.setTimeout(() => {
            const { type, amount, id } = this.props.reward
            showItemTooltip(CLIENT_REWARD_TYPE[type], amount, parseInt(id, 10) || '')
            this._tooltipTimeoutId = undefined
        }, 200)
    }

    handleMouseLeave = () => {
        if (this.isMedalReward) {
            return
        }

        window.clearTimeout(this._tooltipTimeoutId)
        if (this._tooltipTimeoutId === undefined) {
            hideTooltip()
        }
    }

    render() {
        const { reward } = this.props
        const tooltipProps = this.isMedalReward ? {
            'data-tip': true,
            'data-for': this.medalTooltipId,
        } : {}
        const rewardClassNames = cx(
            styles.base,
            styles[`base__${reward.type}`]
        )

        switch (reward.type) {
        case REWARD_TYPE.GOLD:
            return (
                <Gold
                    value={reward.amount}
                    size="large"
                    iconPosition="after"
                    mixClassName={styles.gold}
                />
            )
        case REWARD_TYPE.BONDS:
        case REWARD_TYPE.CLAN_BONDS:
            return (
                <Bons
                    size="large"
                    iconPosition="after"
                    value={reward.amount}
                    mixClassName={styles.bonds}
                />
            )
        default:
            return (
                <div
                    className={rewardClassNames}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                    {...tooltipProps}
                >
                    {
                        reward.amount > 1 &&
                        <span className={styles.counter}>
                            {thousands(reward.amount, false)}
                        </span>
                    }
                    {this.isMedalReward && (
                        <RewardTooltip
                            type={reward.type}
                            id={this.medalTooltipId}
                        />
                    )}
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./containers/WGCWXLeaderboards/components/Reward/Reward.jsx